export default "__VITE_ASSET__e73f938c__"